import { render } from "./PaymentResult.vue?vue&type=template&id=2f75eb22&scoped=true"
import script from "./PaymentResult.vue?vue&type=script&lang=js"
export * from "./PaymentResult.vue?vue&type=script&lang=js"

import "./PaymentResult.vue?vue&type=style&index=0&id=2f75eb22&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f75eb22"]])

export default __exports__